/**
 * Shared bracket pairing for TipTap search editors (auto-close + matching highlight).
 * Keep a single source of truth so pairs never drift between extensions.
 */
export const BRACKET_OPEN_TO_CLOSE: Record<string, string> = {
  "(": ")",
  "[": "]",
  "{": "}",
};

export const BRACKET_CLOSE_TO_OPEN: Record<string, string> = {
  ")": "(",
  "]": "[",
  "}": "{",
};

const closingChars = Object.values(BRACKET_OPEN_TO_CLOSE);

/** Closing delimiters `)`, `]`, `}`. */
export const BRACKET_CLOSING_CHARS = new Set<string>(closingChars);

/** Any bracket character (open or close). */
export const BRACKET_PAIR_CHARS = new Set<string>([
  ...Object.keys(BRACKET_OPEN_TO_CLOSE),
  ...closingChars,
]);
